import { usePropostaForm } from "../context/PropostaFormContext";

export default function PropostaSectionCard({
  title,
  children,
  className = "",
}: {
  title: string;
  children: React.ReactNode;
  className?: string;
}) {
  const { isDark } = usePropostaForm();

  return (
    <div
      className={`rounded-lg border overflow-x-hidden min-w-0 ${
        isDark
          ? "border-gray-700 bg-[#1d2840]"
          : "border-gray-200 bg-white"
      } ${className}`}
    >
      <div
        className={`px-4 py-2.5 border-b ${
          isDark
            ? "border-gray-700 bg-[#24304a]"
            : "border-gray-100 bg-[#f8f9fb]"
        }`}
      >
        <h4 className="text-sm font-semibold text-primary">{title}</h4>
      </div>
      <div className="p-3 sm:p-4 min-w-0">{children}</div>
    </div>
  );
}
